import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import BottomNavBar from '@components/BottomNavBar';
import TopNavBar from '@components/TopNavBar';
import Stats from '@pages/Stats';
import Calendar from '@pages/Calendar';
import Workout from '@pages/Workout';
import Scales from '@pages/Scales';
import Settings from '@pages/Settings';
import Profile from '@pages/Profile';
import WorkoutLog from '@pages/stats_pages/WorkoutLog';
import MuscleDistribution from '@pages/stats_pages/MuscleDistribution';
import ExerciseStats from '@pages/stats_pages/ExerciseStats';
import OverallStats from '@pages/stats_pages/OverallStats';
import ParallaxBackground from '@components/ParallaxBackground';

// TODO PRIORITY
// - sort out body weight into exercises toggle with FaPercentage which includes the logged last weight
// - group exercises ie smith bench and barbell bench
// - superset grouping
// - timer for sets 
// - ability to drag exercises into different orders on active workout
//
// information for new comers on rep ranges to follow. (if new gym goer selected)

// ui changes for workout template pages

// update template after active workout bugs

const Home = () => {
  const navigate = useNavigate();
  
  const [isLoggingWorkout, setIsLoggingWorkout] = useState(
    JSON.parse(localStorage.getItem('isLoggingWorkout')) || false
  );
  const [currentWorkout, setCurrentWorkout] = useState(localStorage.getItem('currentWorkout') || null);

  useEffect(() => {
    const user = localStorage.getItem('googleUser');
    if (!user && !window.location.pathname.includes('/freeweight') && localStorage.getItem('isGuest') != 'true') {
      navigate('/freeweight');
    }
  }, [navigate]);

  // Save state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('isLoggingWorkout', JSON.stringify(isLoggingWorkout));
    localStorage.setItem('currentWorkout', currentWorkout);
  }, [isLoggingWorkout, currentWorkout]);

  return (
    <div style={{ 
      position: 'relative',
      minHeight: '100vh',
      paddingBottom: '60px' // For bottom nav
    }}>
      {/* Background that will parallax */}
      <ParallaxBackground />
      
      {/* Fixed Top Nav */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(0,0,0,0.7)' // Optional: make nav slightly opaque
      }}>
        <TopNavBar />
      </div>
      
      {/* Scrollable Content */}
      <div style={{ 
        paddingTop: '60px', // Match top nav height
        paddingBottom: '60px', // Match bottom nav height
        position: 'relative',
        zIndex: 1
      }}>
        <Routes>
          {/* top level tabs */}
          <Route index element={<Stats />} />
          <Route path="stats" element={<Stats />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="workout" element={<Workout />} />
          <Route path="scales" element={<Scales />} />
          <Route path="settings" element={<Settings />} />
          <Route path="profile" element={<Profile />} />
          
          {/* nested stats pages */}
          <Route path="stats_pages/workout-log" element={<WorkoutLog />} />
          <Route path="stats_pages/muscle-distribution" element={<MuscleDistribution />} />
          <Route path="stats_pages/exercise-stats" element={<ExerciseStats />} />
          <Route path="stats_pages/overall-stats" element={<OverallStats />} />
        </Routes>
      </div>
      
      {/* Fixed Bottom Nav */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(0,0,0,0.7)' // Optional: make nav slightly opaque
      }}>
        <BottomNavBar />
      </div>
    </div>
  );
};

export default Home;